import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Toast,Dialog } from 'vant'
import i18n from '@/i18n'
import { baseUrl } from '@/config';

//接口配置

var instance = axios.create({
    baseURL: baseUrl,//(localStorage['CurrLine']||ApiUrl)+'/api/',
    headers: {
        'Content-Type':'application/x-www-form-urlencoded'
    }
})


let isAuthHandling = false

// 添加请求拦截器
instance.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么
        config.baseURL = baseUrl,//(localStorage['CurrLine']||ApiUrl)+'/api/';
        config.data = config.data || {};
        config.data.lang = localStorage['Language']||'en';
        config.data.url_server = window.location.hostname;
        if(!config.noLogin){
            config.data.token = localStorage['Token'];
        }
        if(!config.fromData){
            config.data = $.param(config.data);
        }
        return config;
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
)

// 添加响应拦截器
instance.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        if (response.data.code > 200 && response.data.code < 206) {
            localStorage.removeItem('Token');
            localStorage.removeItem('UserInfo');
            localStorage.removeItem('BankCardList');
            store.dispatch('UpdateUserInfo', '');
            store.dispatch('UpdateBankCardList', []);
            Toast.clear();
            if (!isAuthHandling) {
                isAuthHandling = true
                Dialog.alert({
                    title: i18n.t('dialog[0]'),
                    confirmButtonText: i18n.t('dialog[1]'),
                    message: response.data.code_dec,
                    closeOnPopstate: true,
                }).then(() => {
                    router.push('/login');
                    isAuthHandling = false;
                }).catch(()=>{
                    router.push('/login');
                    isAuthHandling = false;
                });
            }
        }
        return response;
    },
    error => {
        const html = error && error.response && error.response.data
        const matched = typeof html === 'string' && /<h1>(.*?)<\/h1>/ig.exec(html)
        if (matched && matched[1]) {
            Toast({message: matched[1]});
        }
        return Promise.reject(error);
    }
)

export default instance